<template>
  <div class="data_cont">
    <div class="content_box">
      <div class="padding_box">
        <div class="card_tabBar">
          <div style="display: flex">
            <div class="card_tabBarItem" @click="clicktabitem(item1)" v-for="(item1, index1) in tablist" :key="index1">
              <div :class="`card_clicktabBar ${tabitemindex === item1.id ? 'card_clicktabBarIndex' : ''
                }`">
                <div>
                  {{ item1.title }}
                  <div :class="tabitemindex === item1.id ? 'click_tag' : ''"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="lenged" v-if="tabitemindex == 0">
            <div class="new">
              <div class="point"></div>
              <div class="text">Current Value</div>
            </div>
            <div class="target">
              <div class="point"></div>
              <div class="text" v-if="Number(openIndex) == 1">Set Point</div>
              <!-- {{ Number(openIndex) !== 1 }} -->
              <div class="text" v-if="Number(openIndex) !== 1">Target Value</div>
            </div>
          </div>
        </div>
        <div class="data_box" v-if="tabitemindex == 0">
          <div v-for="(item, index) in allControlData.result.table" class="listbox"
            v-if="allControlData.result.belongs.length == 0" :key="index">
            <div>
              <p class="dataname">{{ item.visible }}</p>
              <p class="dataunit">{{ item.unit }}</p>
            </div>
            <div>
              <div class="container1">
                <div class="progress">
                  <!-- {{ item.current / tag[index].target }} -->
                  <div class="progress-bar" :style="{
                    width: 326.87 * (item.current / tag[index].target) + 'px',
                    'min-width': '60px',
                  }">
                    {{ item.current }}
                  </div>

                  <div class="target" @click="openchange(item, index)">
                    <div class="progress-tagbar" v-if="tag[index].target !== '-'"></div>
                    <div class="target_text" v-if="item.target_type == 0">
                      {{ tag[index].target }}
                    </div>
                    <div class="target_updown" v-else>
                      {{ item.target }}
                    </div>
                  </div>

                  <div style="position: relative">
                    <p>
                      <span class="fudongmubiao" v-if="item.floating_target" style="color: rgb(36, 102, 168)">
                        {{ item.floating_target_label }}
                        <span style="color:rgb(36, 102, 168); font-weight: 600">
                          {{
                            (
                              (item.floating_target[1] +
                                item.floating_target[0]) /
                              2
                            ).toFixed(2)
                          }}
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <el-carousel :autoplay="false" arrow="never" indicator-position="none" ref="carousel"
            v-if="allControlData.result.belongs.length > 0">
            <el-carousel-item v-for="(item, index) in allControlData.result.table" :key="index">
              <div v-for="(iteminfo, index1) in item" class="listbox" :key="index1">
                <div>
                  <p class="dataname">{{ iteminfo.visible }}</p>
                  <p class="dataunit">{{ iteminfo.unit }}</p>
                </div>
                <div>
                  <div class="container1">
                    <div class="progress">
                      <div class="progress-bar" :style="{
                        width:
                          326.87 * (iteminfo.current / iteminfo.target[1]).toFixed(2) +
                          'px',
                        'min-width': '60px',
                      }">
                        {{ iteminfo.current }}
                      </div>

                      <div class="target" @click="openchange(iteminfo, index1)">
                        <div class="progress-tagbar" v-if="tag[index1].target !== '-'"></div>
                        <div class="target_text" v-if="iteminfo.target_type == 0">
                          {{ tag[index1].target }}
                        </div>
                        <div class="target_updown" v-else>
                          {{ iteminfo.target }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="position: relative">
                    <p>
                      <span class="fudongmubiao" v-if="iteminfo.floating_target" style="color:rgb(36, 102, 168)">
                        {{ iteminfo.floating_target_label }}
                        <span style="color:rgb(36, 102, 168); font-weight: 600">
                          {{
                            (
                              (iteminfo.floating_target[1] +
                                iteminfo.floating_target[0]) /
                              2
                            ).toFixed(2)
                          }}
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="data_box" v-if="tabitemindex == 1">
          <div v-for="(item, index) in inflowcod" class="listbox" :key="index">
            <div>
              <p class="dataname">{{ item.name }}</p>
            </div>
            <div>
              <div class="progress">
                <div class="mubiaodiv">
                  <el-input class="mubiao_input" v-model="item.value"
                    :disabled="!roleBtnCodes.includes('AIControl_target_value_edit')"
                    @change="(newValue) => changevalue(newValue, item, index, item)"
                    @keyup.enter.native="enterBlur($event)"></el-input>
                  <div>
                    <el-button type="primary" plain>Confirm</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="distrbute_btns">
        <button :class="active == index ? 'active' : ''" v-for="(item, index) in carousel_list" :key="item.id"
          @click="clickBtn(index)">
          {{ item.name }}
        </button>
      </div>
    </div>

    <el-dialog title="Reminder" :visible.sync="dialogVisible" width="50%" center>
      <span class="dialogtext">
        AI will spare no effort to control&nbsp;
        <span style="color: #2466a8; font-weight: 600">{{ changename }} </span>
        &nbsp;around &nbsp;
        <span style="color: red; font-weight: 600">
          {{ targetnum }}
        </span>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="colsedialog()">Cancel</el-button>
        <el-button type="primary" class="mycommitbtn" @click="commitchange()">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="openIndex == 1 ? 'Set Point' : 'Modify Target Value'" :visible.sync="dialogchange" width="80%"
      center v-if="dialogchange" :modal-append-to-body="false" :before-close="handleClose">
      <div class="change_box">
        <!-- {{ changeitem }} -->
        <div class="change_title">
          {{ changeitem.visible }}
          <!-- {{ tag }} -->
        </div>
        <div class="input_box">
          <div v-if="changeitem.target_type == 0">
            <el-row style="vertical-align: middle">
              <el-col :span="24">
                <div class="mubiaodiv">
                  <!-- @keyup.enter.native="enterBlur($event)" -->
                  <el-input class="changemubiao_input" v-model="tag[changeindex].target" @change="
                    (newValue) => changeAction(newValue, tag[changeindex], changeitem)
                  " :disabled="!changeitem.changeable ||
                    !roleBtnCodes.includes('AIControl_target_value_edit')
                    "></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-else>
            <el-row style="vertical-align: middle">
              <el-col :span="12">
                <div class="mubiaodiv">
                  <span style="margin: 0; margin-bottom: 2px; color: #4d4a4a" class="tag_data">
                    Lower Limit：
                  </span>
                  <el-input class="sx_input" v-model="changeitem.target[0]"
                    @change="(newValue) => changetype(newValue, changeitem, 'Lower Limit')"
                    @keyup.enter.native="enterBlur($event)"
                    :disabled="!changeitem.changeable || !roleBtnCodes.includes('AIControl_target_value_edit')"></el-input>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="mubiaodiv">
                  <span style="margin: 0; margin-bottom: 2px; color: #4d4a4a" class="tag_data">
                    Upper Limit：
                  </span>
                  <el-input class="sx_input" v-model="changeitem.target[1]"
                    @change="(newValue) => changetype(newValue, changeitem, 'Upper Limit')"
                    @keyup.enter.native="enterBlur($event)"
                    :disabled="!changeitem.changeable || !roleBtnCodes.includes('AIControl_target_value_edit')"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="change_unit">
          {{ changeitem.unit }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="colsechangedialog()">Cancel</el-button>
        <el-button type="primary" class="mycommitbtn" @click="commitbtn()">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common.js";
// import config from "@/utils/config";

export default {
  data() {
    return {
      changeindex: null,
      changeitem: null,
      dialogchange: false,
      dialogVisible: false,
      show: true,
      allControlData: null,
      openIndex: null,
      inflowcod: null,
      tablist: [
        {
          id: 0,
          title: "Current Data Monitoring",
        },
      ],
      tabitemindex: 0,
      tag: [],
      datalist: [

      ],
      carousel_list: [],
      active: 0,
      tagmistake: false,
      roleBtnCodes: [],
      changename: "",
      targetnum: "",
    };
  },
  watch: {
    "$store.state.roleBtnCodes": {
      handler(val) {
        this.roleBtnCodes = val || [];
      },
      immediate: true,
    },
  },
  sockets: {
    //连接成功
    connect() { },
    // 接收数据(这个名字问后端)
    data(res) {
      this.allCurrent = JSON.parse(res);
      this.refreshData = this.allCurrent.refresh;
      console.log(this.refreshData);
      for (let i = 0; i < this.refreshData[this.openIndex].length; i++) {
        console.log(this.allControlData.result.table[i].current);
        this.allControlData.result.table[i].current = this.refreshData[this.openIndex][i];
        if (this.allControlData.result.table[i].current == "-999") {
          this.allControlData.result.table[i].current = "NA";
        }
      }
    },
  },
  mounted() {
    this.openIndex = this.$route.query.index;
    this.getControlData(this.openIndex);
    this.getinflowcod(this.openIndex);
  },
  methods: {
    clickBtn(e) {
      console.log(e);

      this.$refs.carousel.setActiveItem(e);

      this.active = e;
    },


    openchange(item, index) {
      console.log(item);
      this.changeitem = item;
      this.changeindex = index;
      this.dialogchange = true;

    },
    async getinflowcod(index) {
      this.tablist = [
        {
          id: 0,
          title: "Current Data Monitoring",
        },
      ];
      // console.log(index);
      const { data: res } = await this.$http.get(
        "/modules/getinput",
        {
          params: { index: index },
        }
      );
      // console.log(res.data.result);
      if (res.data.result.length < 1) {
        // console.log(213213213123);
        // this.show = false
        // this.show = true
      } else {
        console.log(this.tablist);
        this.tablist.push({
          id: 1,
          title: "Manual Input",
        });
        // this.show = false
        this.inflowcod = res.data.result;
      }
    },
    clicktabitem(item1) {
      console.log(item1);
      this.tabitemindex = item1.id;
    },
    async getControlData(index) {
      const { data: res } = await this.$http.get("/modules/init", {
        params: { index: index },
      });
      this.allControlData = res.data;
      console.log(this.allControlData);
      this.tag = [];
      for (let a = 0; a < this.allControlData.result.table.length; a++) {
        if (this.allControlData.result.table[a].current == "-999") {
          this.allControlData.result.table[a].current = "NA";
        }
        if (this.allControlData.result.table[a].target !== "NA") {
          this.tag.push({
            id: this.allControlData.result.table[a].id,
            tag: this.allControlData.result.table[a].tag,
            target: (
              (this.allControlData.result.table[a].target[0] +
                this.allControlData.result.table[a].target[1]) /
              2
            ).toFixed(2),
            fudong: (
              (this.allControlData.result.table[a].target[1] -
                this.allControlData.result.table[a].target[0]) /
              2
            ).toFixed(2),
          });
        } else {
          this.tag.push({
            id: this.allControlData.result.table[a].id,
            tag: this.allControlData.result.table[a].tag,
            target: "-",
            fudong: "-",
          });
        }
      }

      if (this.allControlData.result.belongs.length > 0) {
        let mytablearr = [];
        this.carousel_list = [];
        for (let b = 0; b < this.allControlData.result.belongs.length; b++) {
          this.carousel_list.push({
            name: this.allControlData.result.belongs[b],
            indexarr: [],
          });
        }
        for (let c = 0; c < this.allControlData.result.table.length; c++) {
          for (let d = 0; d < this.carousel_list.length; d++) {
            if (
              this.allControlData.result.table[c].belong == this.carousel_list[d].name
            ) {
              this.carousel_list[d].indexarr.push(
                this.allControlData.result.table[c].index
              );
            }
          }
          this.carousel_list[0].indexarr.push(this.allControlData.result.table[c].index);
        }
        console.log(this.carousel_list);
        for (let a = 0; a < this.allControlData.result.belongs.length; a++) {
          let info = [];
          if (this.allControlData.result.belongs[a] == "All") {
            mytablearr.push(this.allControlData.result.table);
          } else {
            for (let b = 0; b < this.allControlData.result.table.length; b++) {
              if (
                this.allControlData.result.table[b].belong ==
                this.allControlData.result.belongs[a]
              ) {
                console.log(this.allControlData.result.table[b].belong);
                info.push(this.allControlData.result.table[b]);
              }
            }
            mytablearr.push(info);
          }
        }
        console.log(mytablearr);
        this.allControlData.result.table = mytablearr;
      }

      console.log(this.allControlData);
    },
    cbrBtnStyle(index) {
      if (this.allControlData.result.pool[index].flag == true) {
        return { backgroundColor: "#1890ff", color: "fff" };
      } else {
        return { backgroundColor: "#b8b8b8", color: "fff" };
      }
    },
    async changeAction(newValue, row, item) {
      console.log(newValue, row, item);
      this.down = (Number(row.target) - Number(row.fudong)).toFixed(2);
      this.up = (Number(row.target) + Number(row.fudong)).toFixed(2);
      this.time = item.target[2] * 100;
      this.tagid = row.id;
      this.changename = item.visible;
      this.downtext = this.down;
      console.log(Number(row.target));
      if (Number(row.target)) {
        this.tagmistake = false;
      } else {
        this.tagmistake = true;
        return this.$message.warning("请输入格式正确的目标值");
      }
      this.targetnum = row.target;
      if (Number(this.downtext) < 0) {
        this.downtext = 0;
      }

      if (row.mintarget > row.maxtarget) {
        this.getControlData(this.openIndex);
        this.tagmistake = true;
        return this.$message.info("下限设定值不得高于上限设定值！");
      } else {
        this.tagmistake = false;
      }
      // this.dialogVisible = true

      let arr = null;
      console.log(row.target[2]);
      if (row.target[2]) {
        // console.log(row.target);
        arr = "[" + row.target[0] + "," + row.target[1] + "," + row.target[2] + "]";
      } else {
        arr = "[" + row.target[0] + "," + row.target[1] + "]";
      }
    },
    //目标值修改
    async changevalue(newValue, row, index, item) {
      // console.log(newValue, row, index, item);
      // return
      const confirmResult = await this.$confirm("此操作将修改目标值, 是否继续?", "Reminder", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult !== "confirm") {
        this.getIntelligentAerationData();
        return this.$message.info("取消了修改！");
      }
      let setindex = "";
      if (item.name == "仪表数据输入模块") {
        setindex = row.module_index;
      } else {
        setindex = item.module_index;
      }
      const { data: res } = await this.$http.post(
        + "/modules/setinput",
        {
          index: this.openIndex,
          key: row.name,
          newValue: newValue,
        }
      );
      // console.log(res.meta.msg);
      if (res.meta.status != 200) {
        this.getinflowcod(this.openIndex);

        return this.$message.error(res.meta.msg);
      }
      this.$message.success("修改成功");
      this.dialogchange = false;
      this.getControlData(this.openIndex);
      this.getinflowcod(this.openIndex);
    },
    commitbtn() {
      if (this.tagmistake) {
        return this.$message.warning("请输入格式正确的目标值");
      } else {
        this.dialogVisible = true;
      }
    },
    async commitchange() {
      let arr = null;
      console.log(this.time);
      if (this.time) {
        // console.log(row.target);
        arr = "[" + this.down + "," + this.up + "," + this.time / 100 + "]";
      } else {
        arr = "[" + this.down + "," + this.up + "]";
      }
      const { data: res } = await this.$http.post(
        + "/modules/targetset",
        {
          index: this.openIndex,
          id: this.tagid,
          newValue: arr,
        }
      );
      //  console.log(res.meta.msg);
      if (res.meta.status == 403) {
        this.getControlData(this.openIndex);
        return this.$message.error(res.meta.msg);
      }
      if (res.data.result != true) {
        this.getControlData(this.openIndex);
        return this.$message.error(res.meta.msg);
      }
      this.$message.success("success");
      // this.$emit("closedrawer");
      this.dialogchange = false;
      this.dialogVisible = false;
      this.getControlData(this.openIndex);
      this.getinflowcod(this.openIndex);
    },
    async changetype(newValue, row, item) {
      this.down = row.target[0];
      this.up = row.target[1];
      this.time = row.target[2] * 100;
      this.tagid = row.id;
      this.changename = row.visible;
      this.downtext = item;
      this.targettype = row.target_type;
      console.log(typeof Number(this.down) === "number");

      if (typeof Number(this.down) === "number") {
        this.tagmistake = false;
      } else {
        this.tagmistake = true;
        return this.$message.warning("请输入格式正确的目标值");
      }
      if (typeof Number(this.up) === "number") {
        this.tagmistake = false;
      } else {
        this.tagmistake = true;
        return this.$message.warning("请输入格式正确的目标值");
      }
      this.targetnum = row.target;
      if (Number(this.downtext) < 0) {
        this.downtext = 0;
      }
      if (Number(row.target[0]) > Number(row.target[1])) {
        this.getControlData(this.openIndex);
        return this.$message.info("下限设定值不得高于上限设定值！");
      }
      this.dialogVisible = true;
      let arr = null;
      if (row.visible) {
        arr = "[" + row.target[0] + "," + row.target[1] + "," + row.target[2] + "]";
      } else {
        arr = "[" + down + "," + up + "," + item.target[2] + "]";
      }
    },
    colsechangedialog() {
      this.dialogchange = false;
      this.getControlData(this.openIndex);
      this.getinflowcod(this.openIndex);
    },
    colsedialog() {
      this.dialogVisible = false;
      this.getControlData(this.openIndex);
      this.getinflowcod(this.openIndex);
    },
    handleClose() {
      this.dialogchange = false;
      this.getControlData(this.openIndex);
      this.getinflowcod(this.openIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.data_cont {
  position: relative;
  border-radius: 26px;
  // margin-top: 20px;
  background-color: #212121FF;

  .content_box {
    left: 32.5px;
    top: 288.6px;
    width: 773.7px;
    height: 630.5px;
    opacity: 1;
    border-radius: 26px;
    // background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2.6px 9.1px rgba(0, 0, 0, 0.05);

    .padding_box {
      padding-top: 28.6px;
      margin-left: 45.8px;
      margin-right: 24.5px;
    }
  }

  .card_tabBar {
    display: flex;
    justify-content: space-between;

    .card_tabBarItem {
      cursor: pointer;
      margin-right: 15px;
      font-size: 14px;
    }

    .card_clicktabBar {
      margin-right: 20px;
      // width: 157.14px;
      height: 41px;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 30.12px;
      color: rgba(191, 191, 191, 1);
      text-align: left;
      vertical-align: top;
    }

    .card_clicktabBarIndex {
      // width: 157.14px;
      height: 31px;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 30.12px;
      color: #40E0D0FF;
      text-align: left;
      vertical-align: top;
    }

    .click_tag {
      border-top: 2px solid #40E0D0FF;
      color: #40E0D0FF;
    }

    .lenged {
      justify-content: end;

      .text {
        left: 531.76px;
        top: 319.8px;
        width: 173.84px;
        height: 25px;
        opacity: 1;
        /** 文本1 */
        font-size: 16.9px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 24.47px;
        color: rgba(132, 132, 132, 1);
        text-align: left;
        vertical-align: top;
      }

      .new {
        display: flex;
        align-items: center;

        .point {
          left: 510.48px;
          top: 327.6px;
          width: 10.09px;
          height: 10.4px;
          opacity: 1;
          border-radius: 2.6px;
          background: #008080FF;
          margin-right: 11px;
        }
      }

      .target {
        display: flex;
        align-items: center;

        .point {
          margin-right: 11px;
          left: 510.48px;
          top: 327.6px;
          width: 10.09px;
          height: 10.4px;
          opacity: 1;
          border-radius: 2.6px;
          background: #40E0D0FF;
        }
      }
    }
  }

  .data_box {
    margin-top: 41px;
    height: 450px;
    overflow-x: hidden;
    overflow: auto;

    p {
      margin: 0;
    }

    .listbox {
      display: flex;
      margin-bottom: 32px;
    }

    .listbox:last-child {
      display: flex;
      margin-bottom: 0px;
    }

    .dataname {
      left: 78.34px;
      top: 399.1px;
      width: 180.06px;
      // height: 25px;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 24.38px;
      color: rgba(92, 92, 92, 1);
      text-align: left;
      vertical-align: top;
    }

    .dataunit {
      left: 78.34px;
      top: 421.2px;
      width: 55.66px;
      height: 27px;
      opacity: 1;
      /** 文本1 */
      font-size: 16px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 26.35px;
      color: rgba(143, 143, 143, 1);
      text-align: left;
      vertical-align: top;
    }

    .container1 {
      // width: 326.87px;
      text-align: center;

      .progress {
        background: rgba(227, 227, 227, 0);
        border-radius: 5.2px;
      }

      .progress-bar {
        // width: 326.87px;
        height: 24px;
        border-radius: 5.2px;
        background: #008080FF;
        width: 250px;
        // margin-bottom: 5.2px;
        font-size: 18px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 24.38px;
        color: rgba(255, 255, 255, 1);
      }

      .target {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 20.8px;
        line-height: 24.38px;
        // color: rgba(97, 97, 97, 1);
      }

      .progress-tagbar {
        // margin-right: 12px;
        left: 300.78px;
        top: 429px;
        width: 326.87px;
        height: 7.8px;
        opacity: 1;
        border-radius: 5.2px;
        background: #40E0D0FF;
        // width: 50%;
      }

      .target_text {

        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        padding-left: 12px;
      }

      .target_updown {
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        padding-left: 12px;
      }
    }
  }

  .coldiv {
    line-height: 40px;

    .now_data {
      margin: 0;
      margin-bottom: 2px;
      color: #4d4a4a;
      font-size: 16px;
    }

    .now_span {
      font-size: 18px;
      color: #38d0d2;
      margin-right: 6px;
      font-weight: 600;
    }

    .now_input {
      font-size: 18px;
      font-weight: 600;
      width: 100px;
    }
  }

  .mubiaodiv {
    margin-right: 20px;
    // background-color: red;
    display: flex;
    justify-content: center;
    align-items: center;

    .tag_data {
      width: 100px;
      font-size: 16px;
      margin: 0;
      margin-bottom: 2px;
      color: #4d4a4a;
    }
  }

  .mubiao_input {
    margin-right: 42px;
    width: 192.57px;
    height: 40px;
    border-radius: 5.2px;

    border: 0.78px solid rgba(50, 147, 208, 1);
  }

  .sx_input {
    border: 0.78px solid rgba(50, 147, 208, 1);
    border-radius: 5.2px;
    width: 200px;
  }

  .change_box {
    display: flex;
    align-items: center;
    justify-content: center;

    .change_title {
      font-size: 20.8px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 24.38px;
      color: #C5C5C5
    }

    .change_unit {
      font-size: 18.2px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 21.33px;
      color: rgba(166, 166, 166, 1);
    }

    .input_box {
      max-width: 60%;

      .changemubiao_input {
        margin-left: 20px;
        // margin-right: 10px;
        width: 192.57px;
        height: 40px;
        border-radius: 5.2px;

        border: 0.78px solid rgba(50, 147, 208, 1);
      }
    }
  }

  .distrbute_btns {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;

    // bottom: 0;
    // text-align: center;
    // margin: 0 auto;
    button {
      margin-right: 5px;

      border: 2px solid #0099cc;
      border-radius: 6px;
      border: none;
      background: rgb(46, 46, 46);
      color: rgba(166, 166, 166, 1);
      border: 0.64px solid rgb(122, 122, 122);
      // color: white;
      // padding: 16px 32px;
      text-align: center;
      display: inline-block;
      font-size: 13px;
      margin: 4px 2px;
      height: 25px;
      width: 40px;
    }
  }

  .active {
    background: rgb(31, 46, 64) !important;
    border: 0.64px solid rgb(36, 102, 168) !important;
    color: rgb(36, 102, 168) !important;
  }


  .data_box::-webkit-scrollbar {
    height: 6px;
    width: 10px;
  }


  .data_box::-webkit-scrollbar-corner {
    background-color: transparent;
  }


  .data_box::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(214, 214, 214, 1);
  }


  .data_box::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: rgba(240, 240, 240, 1);
  }


  .data_box::-webkit-scrollbar-button {}

  ::v-deep.el-dialog__wrapper {
    position: absolute !important;
  }

  ::v-deep .v-modal {
    position: absolute !important;
    background-color: rgba(249, 250, 254, 0.7) !important;
  }

  ::v-deep .el-overlay {}

  ::v-deep .el-input {
    font-size: 20px;
  }

  ::v-deep .el-carousel__container {
    height: 452px;
  }

  ::v-deep.el-carousel__item {
    overflow-y: auto;
  }

  ::v-deep .el-dialog__title {
    color: #38d0d2;
  }
}
</style>
